export enum SelectorMode {
  SINGLE = 'SINGLE',
  MULTI = 'MULTI',
  MULTI_WITH_SEARCH = 'MULTI_WITH_SEARCH',
}